import React, { useState } from "react";
import { CreateProductType } from "../../types";
import { useGetCategoryQuery } from "../../../../../hooks/CategoryManagement/useGetCategoryQuery";
import Dropdown from "./Dropdown";
import { formatNumberWithCommas } from "utils/formatNumberWithCommas";
import Input from "Components/Input";
import PriceInput from "Components/PriceInput";
import Textarea from "Components/Textarea";

const BasicIinformationForm = ({
  setActive,
  handleInputChange,
  handleNumberInputChange,
  payload,
  setPayload,
  edit,
}: {
  setActive: any;
  handleInputChange: any;
  payload: CreateProductType;
  handleNumberInputChange: any;
  setPayload: React.Dispatch<React.SetStateAction<CreateProductType>>;
  edit?: boolean;
}) => {
  const [validity, setValidity] = useState(false);
  const { data } = useGetCategoryQuery({});

  const handleCategoryChange = (categoryId: string) => {
    setPayload((prevPayload) => {
      const isSelected = prevPayload.categories.includes(categoryId);
      const newCategories = isSelected
        ? prevPayload.categories.filter((id) => id !== categoryId)
        : [...prevPayload.categories, categoryId];

      return { ...prevPayload, categories: newCategories };
    });
  };

  return (
    <div className="mx-auto max-w-[700px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px]">
      <div className="p-[20px] font-medium border-b-[1px] border-[#eeeeee]">
        Basic Information
      </div>
      <div className="p-[20px]">
        <Input
          type="text"
          name="name"
          label="Product Name"
          value={payload?.name}
          onChange={handleInputChange}
          placeholder="Enter Product Name"
        />
        <div className="">
          <Dropdown
            label="categories"
            placeholder={"--Select Categories--"}
            payload={payload}
            setPayload={setPayload}
          />
          <div className="mt-3">
            <Input
              type="text"
              name="brandName"
              label="Brand Name"
              value={payload?.brandName}
              onChange={handleInputChange}
              placeholder="Enter Brand Name"
            />
          </div>
        </div>
        <div className="flex gap-2 mt-3">
          <div className="w-6/12">
            <PriceInput
              label="Unit Price"
              name="unitPrice"
              value={formatNumberWithCommas(payload?.unitPrice)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Bulk Price"
              name="bulkPrice"
              value={formatNumberWithCommas(payload?.bulkPrice)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
        </div>
        <div className="">
          <Textarea
            name="description"
            value={payload?.description}
            onChange={handleInputChange}
            placeholder=""
            label="Product description"
          />
        </div>
        <button
          className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 ${
            validity === false ? "bg-brown opacity-50" : "bg-orange"
          }`}
          onClick={() => setActive(1)}
        >
          {edit ? "Next" : "Proceed"}
        </button>
      </div>
    </div>
  );
};

export default BasicIinformationForm;
